import { z } from "zod";

export enum DictionaryBrandSchemaEnum {
	DictionaryBrand = "DictionaryBrand"
};

export const DictionaryBrandSchema = z.object({
	"@id": z.string(), // "/api/dictionary_brands/1"
	"@type": z.string(), // "DictionaryBrand"
	id: z.number(), // 1
	libelle: z.string(), // "Brand 1"
	hb_brand_id: z.string(), // "1"
	hb_brand_libelle: z.string(), // "Brand 1"
}).describe(DictionaryBrandSchemaEnum.DictionaryBrand);

export type DictionaryBrand = z.infer<typeof DictionaryBrandSchema>;
